import { SvgIcon } from '@mui/material';
import React, { ReactElement } from 'react';

import { theme } from '../../theme';

export interface FavoriteIconProps {
  selected?: boolean;
}

export const FavoriteIcon = ({
  selected = false,
}: FavoriteIconProps): ReactElement => {
  const color = selected
    ? theme.palette.primary.main
    : theme.palette.neutral.darker;
  const backgroundColor = selected
    ? theme.palette.vibrant.primary
    : theme.palette.neutral.light;
  const borderColor = selected ? backgroundColor : '#fff';
  return (
    <SvgIcon style={{ fontSize: '1em' }} viewBox="0 0 35 35.5">
      <g transform="translate(0 0)">
        <g transform="translate(1.66 1.121)">
          <g
            transform="translate(-1.66 -1.121)"
            fill={backgroundColor}
            stroke={borderColor}
            strokeWidth="1"
          >
            <rect width="35" height="35.5" rx="17.5" stroke="none" />
            <rect
              x="0.5"
              y="0.5"
              width="34"
              height="34.5"
              rx="17"
              fill="none"
            />
          </g>
        </g>
        <path
          d="M13,17.868,19.18,21.5l-1.64-6.845L23,10.049l-7.19-.594L13,3,10.19,9.456,3,10.049l5.46,4.606L6.82,21.5Z"
          transform="translate(4.5 5.5)"
          fill={color}
        />
      </g>
    </SvgIcon>
  );
};
